<template>
  <div class="bg-header" style="font-family: Montserrat; color:white">
    <v-container>
      <v-row align="center">
        <v-col cols="12" md="2" class="text-center">
          <div class="logo">
            <img src="https://chess-qa.s3.amazonaws.com/AJEFECH-transp.png" alt="Logo">
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <div class="text-center mt-5 title">
            Ajedrez Federado de Chile
          </div>
          <div class="header-chess">
            <nav class="optionmenu">
              <ul class="optionul">
                <li class="option"><a class="link" href="/">Inicio</a></li>
                <li class="option">
                  <a class="link" href="javascript:void(0);">Torneos</a>
                  <v-menu activator="parent">
                    <v-list>
                      <v-list-item href="/torneos/">
                        <v-list-item-title>Próximos Torneos</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/torneos_contabilizados/">
                        <v-list-item-title>Torneos Rankeados</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </li>
                <li class="option"><a class="link" href="javascript:void(0);">Jugadores</a>
                  <v-menu activator="parent">
                    <v-list>
                      <v-list-item href="/jugadores/">
                        <v-list-item-title>Listado</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/ranking_jugadores/">
                        <v-list-item-title>Ranking</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </li>
                <li v-if="is_authenticated" class="option">
                  <a class="link" href="javascript:void(0);">Administración</a>
                  <v-menu activator="parent">
                    <v-list>
                      <v-list-item href="/mis_torneos/">
                        <v-list-item-title>Mis Torneos</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/mis_articulos/">
                        <v-list-item-title>Mis Artículos</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/clubes/">
                        <v-list-item-title>Clubes</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/cambiar_contraseña/">
                        <v-list-item-title>Cambiar Contraseña</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/logout/">
                        <v-list-item-title>Salir</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </li>
                 <li v-if="infos" class="option"><a class="link" href="javascript:void(0);">Organizacion</a>
                <v-menu activator="parent">
                  <v-list>
                    <v-list-item v-for="rule in infos" :key="rule.id" :href="'/reglamento/'+rule.id">
                      <v-list-item-title>{{ rule.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </li>
              <li v-if="rules" class="option"><a class="link" href="javascript:void(0);">Reglamentos</a>
                <v-menu activator="parent">
                  <v-list>
                    <v-list-item v-for="rule in rules" :key="rule.id" :href="'/reglamento/'+rule.id">
                      <v-list-item-title>{{ rule.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </li>
              <li class="option"><a class="link" href="javascript:void(0);">Comunidad</a>
                <v-menu activator="parent">
                  <v-list>
                                      <v-list-item href="/arbitros/">
                      <v-list-item-title>Arbitros</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/entrenadores/">
                      <v-list-item-title>Entrenadores</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/organizadores/">
                      <v-list-item-title>Organizadores</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/administradores/">
                      <v-list-item-title>Administradores</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="is_admin" href="/accesos/">
                      <v-list-item-title>Accesos</v-list-item-title>
                    </v-list-item>
                    </v-list>
                </v-menu>
              </li>
              </ul>
            </nav>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MenuChess",
  computed: {
    ...mapState(["is_authenticated", "is_admin", "rules", "infos"]),
  },
};
</script>

<style scoped>
.header-chess {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}

.title {
  font-size: 40px;
  font-weight: bold;
}

.optionmenu {
  display: flex;
  justify-content: center;
  width: 100%;
}

.optionul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  justify-content: center;
}

.option {
  margin: 0 15px;
}

.link {
  font-size: 20px;
  text-decoration: none;
  color: white;
  transition: 0.3s;
}

.link:hover {
  color: #f0a500;
}

.logo img {
  max-width: 100px;
  height: auto;
}

/* Responsive */
@media (max-width: 768px) {
  .title {
    font-size: 30px;
  }

  .optionul {
    flex-direction: column;
    align-items: center;
  }

  .option {
    margin: 10px 0;
  }

  .logo img {
    max-width: 80px;
  }
}
</style>